import "./SbcSeguridadDeVoz.module.css";
import Header from "@/reusable_sections/Header";
import IntroducciNSbc from "./sections/IntroducciNSbc";
import CaracterSticasDeSeguridad from "./sections/CaracterSticasDeSeguridad";
import ModelosDeSbcDinstar from "./sections/ModelosDeSbcDinstar";
import Productvideodemo from "./sections/Productvideodemo";
import SolicitarInformacion from "./sections/SolicitarInformacion";
import Footer from "@/reusable_sections/Footer";
export default function SbcSeguridadDeVozPage() {
  return <div>
      <Header />
      <IntroducciNSbc />
      <CaracterSticasDeSeguridad />
      <ModelosDeSbcDinstar />
      <Productvideodemo />
      <SolicitarInformacion />
      <Footer />
    </div>;
}